import {
  Stack,
  styled,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import { Loading } from 'components/Loading'
import { Error } from 'components/Error'
import { TablePagination } from 'components/TablePagination'
import { useTranslation } from 'react-i18next'
import { useQueryState } from 'react-router-use-location-state'
import { useAnnouncementsQuery } from 'services/announcements'
import { formatTimeStampToDate } from 'hooks/date/formattedTime'

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
}))

type Props = {
  tenderId: string
}

export const SupplierAnnouncementTable = ({ tenderId }: Props) => {
  const { t } = useTranslation()

  const [page, setPage] = useQueryState('page', 0)
  const rowsPerPage = 10

  const args = {
    page,
    size: rowsPerPage,
    tenderId,
  } as const

  const { data: announcements, isLoading, isError } = useAnnouncementsQuery(args)

  if (isLoading) return <Loading fullPage={false} />

  if (isError) return <Error />

  if (announcements === undefined) {
    return <></>
  }

  return (
    <Stack>
      <TableContainer sx={{ backgroundColor: '#fff' }}>
        <Table>
          <TableHead>
            <TableRow>
              <StyledTableCell>{t('suppliersInformationList')}</StyledTableCell>
              <StyledTableCell></StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {announcements.items.map(
              ({ id, announcementText, announcementDate }) => (
                <TableRow key={id}>
                  <TableCell>{announcementText}</TableCell>
                  <TableCell>{formatTimeStampToDate(announcementDate)}</TableCell>
                </TableRow>
              )
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {announcements.info.totalRows > 0 && (
        <TablePagination
          total={announcements.info.totalRows}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={setPage}
        />
      )}
    </Stack>
  )
}
